(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFormCategoryDialogController', EventFormCategoryDialogController);

    EventFormCategoryDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'EventFormCategory'];

    function EventFormCategoryDialogController ($scope, $stateParams, $uibModalInstance, entity, EventFormCategory) {
        var vm = this;
        vm.EventFormCategory = entity;
        vm.EventFormCategory.visibleOnSmartphone = vm.EventFormCategory.visibleOnSmartphone !== false;
        vm.load = function(id) {
            EventFormCategory.get({id : id}, function(result) {
                vm.EventFormCategory = result;
                vm.EventFormCategory.visibleOnSmartphone = vm.EventFormCategory.visibleOnSmartphone !== false;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:EventFormCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.EventFormCategory.id !== null) {
                EventFormCategory.update(vm.EventFormCategory, onSaveSuccess, onSaveError);
            } else {
                EventFormCategory.save(vm.EventFormCategory, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
